export type ClientKey =
  | 'KOSPINUS'
  | 'SUKMA'
  | 'DANAGUNG'
  | 'BAV'
  | 'IMA'
  | 'KRRN';

export type AppServer = 'DEVELOPMENT' | 'STAGING' | 'PRODUCTION';

export const CLIENT_IDS: Record<
  ClientKey,
  Partial<Record<AppServer, string | null>>
> = {
  KOSPINUS: {
    DEVELOPMENT: 'TOP0010001',
    STAGING: '001',
    PRODUCTION: '001',
  },
  SUKMA: {
    DEVELOPMENT: 'TOP0010002',
    STAGING: 'SUKHI0226',
    PRODUCTION: 'SUKHI0226',
  },
  DANAGUNG: {
    DEVELOPMENT: 'TOP0010003',
    STAGING: 'DNGG0326',
    PRODUCTION: null,
  },
  BAV: {
    DEVELOPMENT: 'TOP0010004',
    STAGING: 'BHAVN0526',
    PRODUCTION: null,
  },
  IMA: {
    DEVELOPMENT: 'TOP0010005',
    STAGING: null,
    PRODUCTION: null,
  },
  KRRN: {
    DEVELOPMENT: 'TOP0010006',
    STAGING: null,
    PRODUCTION: null,
  },
};
